var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',_vm._b({class:['mb-3', _vm.computedClasses],style:(_vm.computedStyles)},'b-card',{ id: _vm.id },false),[_c('WidgetGroup',{attrs:{"widgets":_vm.children}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }